export default __webpack_public_path__ + "static/media/mock-banner.d89b1d56.png";